export const ReleaseInfo = Object.freeze({
  releaseVersion: '2026.2.26-0909.16',
  commitId: '312b02276586fcea58c046a16faa112953477b82',
  commitTime: '2026-02-26T09:09:16.000Z',
});
